/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as r from "react";
import { DragClue as t } from "@progress/kendo-react-data-tools";
import { GridContext as o } from "../GridClientWrapper.mjs";
const i = (n) => {
  const e = r.useContext(o);
  return /* @__PURE__ */ r.createElement(t, { ref: e.dragLogicRef.current.refDragElementClue });
};
export {
  i as GridDragClue
};
